export default __webpack_public_path__ + "static/media/logo.aa6408d7.JPG";